import React from 'react';

import ArticleListingItem from '$partials/listings/article-listing-item';
import Carousel, { CarouselSlide } from '$partials/ui/carousel';
import { CarouselProvider } from '$contexts/carousel';
import Button from '$partials/ui/button.jsx';
import { useLocale } from '$contexts/locale';
import { IconChevronSprite } from '$partials/icons/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleArticleCarousel}
 */

const ModuleArticleCarousel = ({
    eyebrow,
    heading,
    bodyCopy,
    ctaLabel,
    ctaLink,
    itemsCollection,
    isArticlePage,
}) => {

    const items = itemsCollection?.items || [];

    const { formatURI, translate: t } = useLocale();
    return (

        <section className='relative py-40 lg:py-80 overflow-hidden'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='flex flex-col sm:flex-row gap-y-24 justify-between col-wrapper'>
                    <div className='col-padding sm:w-10/12 md:w-7/12 lg:w-6/12'>
                        {eyebrow && (
                            <p
                                className='type-style-eyebrow text-text-accent mb-12'>
                                {eyebrow}
                            </p>
                        )}

                        <h2 className={`${isArticlePage ? 'type-style-4' : 'type-style-3-extended'} text-text-primary`}>
                            {heading}
                        </h2>

                        {bodyCopy && (
                            <p className='type-style-body text-text-secondary mt-10'>
                                {bodyCopy}
                            </p>
                        )}
                    </div>
                    {ctaLabel && ctaLink && (
                        <div className='col-padding sm:self-end'>
                            <Button
                                as='a'
                                className='button button--sand h-min w-min'
                                href={formatURI(ctaLink)}>
                                <span className='button__label--animate'>
                                    <span>{ctaLabel}</span>
                                </span>
                                <span className='button__icon button__icon--animate'>
                                    <IconChevronSprite />
                                </span>
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            <div className='overflow-hidden w-screen max-w-screen left-1/2 relative -translate-x-1/2 mt-40'>
                <div className='layout-container layout-site-outer-padding overflow-visible'>
                    <CarouselProvider>
                        <Carousel className='h-auto col-wrapper'>
                            {items.map((item, i) => {
                                if (!item) { return null; }
                                return (
                                    <CarouselSlide
                                        className='h-auto flex flex-wrap w-5/6 sm:w-[41.7%] md:w-[30.6%] lg:w-[27.77%] col-padding'
                                        index={i}
                                        key={`${heading}-article-${i}`}>
                                        <article
                                            aria-label={item.pageTitle}
                                            aria-posinset={i + 1}
                                            className='w-full'
                                            tabIndex={-1}>
                                            <ArticleListingItem
                                                {...item} />
                                        </article>
                                    </CarouselSlide>
                                );
                            })}
                        </Carousel>
                    </CarouselProvider>
                </div>
            </div>
        </section>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ModuleArticleCarousel;
